import React from "react";
import { Link } from "react-router-dom";

export default function CreativeVersionsLabels(props) {
	const { dependentValues, value } = props;
	const { creativeId, libraryId, versionId } = dependentValues;

	// Values of 0 shouldn't be rendered at all
	if (value === 0) {
		return null;
	}

	return (
		<Link
			to={`/library/${libraryId}/creative/${creativeId}/versions/${versionId}/modal/preview-version?showLabels=true`}
		>
			{value}
		</Link>
	);
}
